import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import "../umzug/umzug.css";
import HeroSection from "../heroSection/HeroSection";
import heroPhoto from "../../assets/images/photo.jpg";
import Footer from "../footer/Footer";
import { useTranslation } from "react-i18next";
import SEO from "../SEO";
import UmzugNavbarMenu from "../heroSection/UmzugNavbarMenu";
import { AiFillTag, AiOutlineLike, AiOutlineSafety } from "react-icons/ai";
import { FaCalculator, FaEuroSign, FaHeadphones, FaTasks, FaTruckMoving, FaUsers } from "react-icons/fa";
import { SlEarphones } from "react-icons/sl";
import { MdMoneyOff, MdOutlineAttachMoney } from "react-icons/md";
import { RiLock2Fill } from "react-icons/ri";
import { IoLocationSharp, IoTimeOutline } from "react-icons/io5";
import { CgCircleci } from "react-icons/cg";
import { LuNotebookPen, LuNotepadText } from "react-icons/lu";
import { ImStarEmpty } from "react-icons/im";
import { TbCurrencyEuroOff, TbWorld } from "react-icons/tb";
import { FiUsers } from "react-icons/fi";
import { BiSolidLike } from "react-icons/bi";
import IMG_HERO_BG from "../../assets/images/fahrzeugTransport-bg.png";
import Car1 from "../../assets/images/cars/car1.jpg";
import Car2 from "../../assets/images/cars/car2.jpg";
import Car3 from "../../assets/images/cars/car3.jpg";
import Van1 from "../../assets/images/cars/van1.jpg";
import Van2 from "../../assets/images/cars/van2.jpg";
import Moto from "../../assets/images/cars/moto1.jpg";
import { useNavigate } from "react-router-dom";



/* ── Unsplash image URLs – replace with local assets if preferred ── */
// const IMG_HERO_BG =
//   "https://tuggerahremovals.com.au/wp-content/uploads/Tuggerah-Removals-and-storage-carton-loading-truck.webp";

export default function FahrzeugTransport({
  showNavbar = true,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  

  const trustBadges = [
    { 
      icon: <FaEuroSign />, 
      label1: t("fahrzeugtransport.trust.free.label1", "Kostenlos &"), 
      label2: t("fahrzeugtransport.trust.free.label2", "unverbindlich") 
    },
    { 
      icon: <AiOutlineSafety />, 
      label1: t("fahrzeugtransport.trust.secure.label1", "Geprüfte &"), 
      label2: t("fahrzeugtransport.trust.secure.label2", "zuverlässige Partner") 
    },
    { 
      icon: <IoTimeOutline />, 
      label1: t("fahrzeugtransport.trust.fast.label1", "Schnelle"), 
      label2: t("fahrzeugtransport.trust.fast.label2", "Angebote") 
    },
    { 
      icon: <FiUsers />, 
      label1: t("fahrzeugtransport.trust.user.label1", "Schnelle"), 
      label2: t("fahrzeugtransport.trust.user.label2", "Angebote") 
    },
  ]

  const whyCards = [
    {
      icon: <FaUsers />,
      title: t("mobeltransport.why.card1.title", "Viele Angebote vergleichen"),
      text: t(
        "mobeltransport.why.card1.text",
        "Erhalten Sie mehrere Angebote und wählen Sie das beste für Ihren mobeltransport."
      ),
    },
    {
      icon: <AiFillTag />,
      title: t("mobeltransport.why.card2.title", "Bis zu 30% sparen"),
      text: t(
        "mobeltransport.why.card2.text",
        "Durch den Vergleich sparen Sie Zeit und Geld bei Ihrem mobeltransport."
      ),
    },
    {
      icon: <BiSolidLike />,
      title: t("mobeltransport.why.card3.title", "Geprüfte mobelTransportsfirmen"),
      text: t(
        "mobeltransport.why.card3.text",
        "Alle Partner werden von uns geprüft und laufend bewertet."
      ),
    },
    {
      icon: <FaHeadphones />,
      title: t("mobeltransport.why.card4.title", "Persönlicher Support"),
      text: t(
        "mobeltransport.why.card4.text",
        "Unser Team hilft Ihnen bei Fragen rund um Ihren Umzug weiter."
      ),
    },
  ];

  const howSteps = [
    {
      num: "1",
      icon: <LuNotebookPen />,
      title: t("fahrzeugtransport.how.step1.title"),
      text: t("fahrzeugtransport.how.step1.text"),
    },
    {
      num: "2",
      icon: <LuNotepadText />,
      title: t("fahrzeugtransport.how.step2.title"),
      text: t("fahrzeugtransport.how.step2.text"),
    },
    {
      num: "3",
      icon: <FaTasks />,
      title: t("fahrzeugtransport.how.step3.title"),
      text: t( "fahrzeugtransport.how.step3.text"),
    },
    {
      num: "4",
      icon: <FaTruckMoving />,
      title: t("fahrzeugtransport.how.step4.title"),
      text: t("fahrzeugtransport.how.step4.text"),
    },
  ];

  const trustCards = [
    {
      icon: <TbCurrencyEuroOff />,
      title: t("fahrzeugtransport.trustBar.free.title"),
      text: t("fahrzeugtransport.trustBar.free.text"),
    },
    {
      icon: <RiLock2Fill />,
      title: t("fahrzeugtransport.trustBar.secure.title"),
      text: t("fahrzeugtransport.trustBar.secure.text"),
    },
    {
      icon: <IoLocationSharp />,
      title: t("fahrzeugtransport.trustBar.fast.title"),
      text: t("fahrzeugtransport.trustBar.fast.text"),
    },
    {
      icon: <IoTimeOutline />,
      title: t("fahrzeugtransport.trustBar.nationwide.title"),
      text: t("fahrzeugtransport.trustBar.nationwide.text"),
    },
    {
      icon: <ImStarEmpty />,
      title: t("fahrzeugtransport.trustBar.international.title"),
      text: t("fahrzeugtransport.trustBar.international.text"),
    },
  ];

  const carsCards = [
    {
      icon: Car1,
      title: t("fahrzeugtransport.solutions.carsCards.title1")
    },
    {
      icon: Car2,
      title: t("fahrzeugtransport.solutions.carsCards.title2")
    },
    {
      icon: Van1,
      title: t("fahrzeugtransport.solutions.carsCards.title3")
    },
    {
      icon: Car3,
      title: t("fahrzeugtransport.solutions.carsCards.title4")
    },
    {
      icon: Moto,
      title: t("fahrzeugtransport.solutions.carsCards.title5")
    },
    {
      icon: Van2,
      title: t("fahrzeugtransport.solutions.carsCards.title6")
    },
  ];

  const solutionsCards = [
    {
      icon: <AiOutlineSafety />,
      title: t("fahrzeugtransport.solutions.cta.free.title"),
      text: t("fahrzeugtransport.solutions.cta.free.text"),
    },
    {
      icon: <RiLock2Fill />,
      title: t("fahrzeugtransport.solutions.cta.secure.title"),
      text: t("fahrzeugtransport.solutions.cta.secure.text"),
    },
    {
      icon: <TbWorld />,
      title: t("fahrzeugtransport.solutions.cta.international.title"),
      text: t("fahrzeugtransport.solutions.cta.international.text"),
    },
  ];

  const transportierenBox = [
    {
      title: t("fahrzeugtransport.hero.box1.title")
    },
    {
      title: t("fahrzeugtransport.hero.box2.title")
    },
    {
      title: t("fahrzeugtransport.hero.box3.title")
    },
    {
      title: t("fahrzeugtransport.hero.box4.title")
    },
    {
      title: t("fahrzeugtransport.hero.box5.title")
    },
    {
      title: t("fahrzeugtransport.hero.box6.title")
    },
    {
      title: t("fahrzeugtransport.hero.box7.title")
    },
  ];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);


  const handleSelect = () => {
    setTimeout(() => {
      navigate(`/transport?type=car`);
    }, 150);
  };

  /* ─────────────────────────── render ─────────────────────────── */
  return (
    <>
      <SEO
        title={t("fahrzeugtransport.seo.title")}
        description={t("fahrzeugtransport.seo.description")}
      />

      {/* ── Original HeroSection (Navbar etc.) ── */}
      {showNavbar && <UmzugNavbarMenu />}

      {/* ════════════════════════════════════════
          HERO – "mobelTransport leicht gemacht"
      ════════════════════════════════════════ */}
      <section
        className="umzug-hero"
        style={{
          backgroundImage: `linear-gradient(to right, rgb(27 27 27 / 97%) 45%, rgb(51 51 51 / 55%) 70%, transparent 100%), url(${IMG_HERO_BG})`,
        }}
        aria-label="Hero"
      >
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <div className="hero-content" data-aos="fade-right">
            <h6 className="hero-subtitle2">{t("fahrzeugtransport.hero.subtitle2")}</h6>

            <h1>
              {t("fahrzeugtransport.hero.title")}
              <span>{t("fahrzeugtransport.hero.tagline")}</span>
            </h1>

            <p className="hero-subtitle">
              {t("fahrzeugtransport.hero.subtitle")}
            </p>

            {/* ── Trust badges ── */}
            <div className="trust-badges">
              {trustBadges.map(({ icon, label1, label2 }, i) => (
                <div className="trust-badge" key={i}>
                  <div className="badge-icon" aria-hidden="true">
                    {icon}
                  </div>
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: label1 }} />
                    <div>{label2}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* ── CTA button ── */}
            <a onClick={() => handleSelect()} className="btn-orange">
              {t("mobeltransport.hero.cta", "Jetzt MobelTransportangebot erhalten")} →
            </a>

            <p className="hero-data-note">
              <AiOutlineSafety /> {" "}
              {t(
                "mobeltransport.hero.dataNote",
                "Ihre Daten sind bei uns sicher und werden nicht weitergegeben."
              )}
            </p>

          </div>

          {/* ── "Wir transportieren" Box ── */}
          <div className="hero-transport-box" data-aos="fade-up" data-aos-delay="200">
            <h6>{t("mobeltransport.hero.box.title", "Wir transportieren")}:</h6>
            <ul>
              {transportierenBox.map(({title}, i) => (
                <li key={i}>
                  <span className="check-icon">✓</span> {title}
                </li>
              ))}
            </ul>
          </div>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          WHY TRANSCIROX
      ════════════════════════════════════════ */}
      <section className="why-section">
        <Container>
          <h2 className="section-title mb-5" data-aos="fade-up">
            {t("mobeltransport.why.title", "Warum TransCirox?")}
          </h2>
          {/* <p className="section-subtitle" data-aos="fade-up" data-aos-delay="50">
            {t("mobeltransport.why.subtitle", "Ihre Vorteile auf einen Blick")}
          </p> */}

          <Row className="g-4 justify-content-center">
            {whyCards.map(({ icon, title, text }, i) => (
              <Col xs={12} sm={6} lg={3} key={i} data-aos="fade-up" data-aos-delay={i * 80}>
                <div className="why-card">
                  <div className="icon-wrap" aria-hidden="true">
                    {icon}
                  </div>
                  <h5>{title}</h5>
                  <p>{text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          HOW IT WORKS
      ════════════════════════════════════════ */}
      <section className="how-section">
        <Container>
          <h2 className="section-title" data-aos="fade-up">
            {t("mobeltransport.how.title", "So einfach funktioniert's")}
          </h2>

          <div className="steps-container" data-aos="fade-up" data-aos-delay="100">
            <div className="steps-row">
              {howSteps.map(({ num, icon, title, text }, i, arr) => (
                <div className="step-item" key={i}>
                  <div className="step-circle">
                    <span className="step-number">{num}</span>
                    <div className="step-icon">{icon}</div>
                  </div>
                  {i < arr.length - 1 && (
                    <div className="step-connector" aria-hidden="true">
                      <div className="connector-line"></div>
                      {/* <div className="connector-arrow">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path
                            d="M6 0L6 9"
                            stroke="#ff6b00"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                          <path
                            d="M3 6L6 9L9 6"
                            stroke="#ff6b00"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div> */}
                    </div>
                  )}
                  <h6 className="step-title">{title}</h6>
                  <p className="step-text">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      {/* ════════════════════════════════════════
          SOLUTIONS – "Für jeden mobelTransport"
      ════════════════════════════════════════ */}
      <section className="solutions-section">
        <Container>

          <h2 className="section-title" data-aos="fade-up">
            {t("fahrzeugtransport.solutions.title1")}
          </h2>

          {/* Services Section */}
            <Row className="g-4 text-center my-5">
              {carsCards.map(
                ({icon, title}, i) => (
                  <Col
                    xs={12}
                    md={4}
                    lg={2}
                    key={i}
                    data-aos="zoom-in"
                    data-aos-delay={i * 200}
                  >
                    <div className="shadow-sm border-0 rounded-4 hover-zoom">
                      <img
                        src={icon}
                        alt={t(`transportPage.services.imageAlt${i + 1}`)}
                        className="img-fluid mb-2 hover-zoom-image"
                        style={{width: "auto", height: "250px", borderRadius: "10px"}}
                      />
                      <h6>{title}</h6>
                    </div>
                  </Col>
                ),
              )}
            </Row>

            <section className="why-card text-start" id="angebot" data-aos="fade-up">
              <Container>
                <Row className="align-items-center gy-4">
                  <Col xs="auto" md={1}>
                    <div className="cta-icon-wrap" aria-hidden="true">
                      <AiOutlineSafety />
                    </div>
                  </Col>

                  <Col className="cta-text" md={4}>
                    <h3>
                      {t("fahrzeugtransport.solutions.cta.title")}
                    </h3>
                    <p>
                      {t("fahrzeugtransport.solutions.cta.text")}
                    </p>
                  </Col>

                  <Col className="cta-action" md={6}>
                    <Row className="d-flex align-items-center flex-wrap justify-content-around gy-4">
                      {solutionsCards.map(({ icon, title, text }, i) => (
                        <Col xs={6} md={2} key={i}>
                          <div className="trust-bar-item">
                            <div className="tb-icon" aria-hidden="true">
                              {icon}
                            </div>
                            <div>
                              <h6>{title}</h6>
                              <h6>{text}</h6>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </Row>
              </Container>
            </section>

        </Container>
      </section>

      {/* ════════════════════════════════════════
          BOTTOM TRUST BAR
      ════════════════════════════════════════ */}
      <section className="trust-bar">
        <Container>

          {/* ════════════════════════════════════════
               CTA DARK SECTION
           ════════════════════════════════════════ */}
          <section className="cta-section" id="angebot" data-aos="fade-up">
            <Container>
              <Row className="align-items-center gy-4">
                <Col xs="auto">
                  <div className="cta-icon-wrap" aria-hidden="true">
                    <FaCalculator />
                  </div>
                </Col>

                <Col className="cta-text">
                  <h3>
                    {t("fahrzeugtransport.cta.title")}
                  </h3>
                  <p>
                    {t("fahrzeugtransport.cta.text")}
                  </p>
                </Col>

                <Col xs={12} sm="auto" className="cta-action text-center">
                  <a onClick={() => handleSelect()} className="btn-orange">
                    {t("palettentransport.cta.btn")} →
                  </a>
                  <p className="time-note">
                    {t("palettentransport.cta.timeNote")}
                  </p>
                </Col>
              </Row>
            </Container>
          </section>

          <Row className="d-flex align-items-center flex-wrap justify-content-between gy-4">
            {trustCards.map(({ icon, title, text }, i) => (
              <Col xs={6} md={2} key={i}>
                <div className="trust-bar-item">
                  <div className="tb-icon" aria-hidden="true">
                    {icon}
                  </div>
                  <div>
                    <h6>{title}</h6>
                    <p>{text}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>


      {/* ════════════════════════════════════════
          FAQ
      ════════════════════════════════════════ */}
      <div className="faq-umzug">
        <p className="fw-bold text-center">{t("umzug.FaqUmzug.hero_description")}</p>

        <Row>
          <Col className="d-flex justify-content-center p-3">
            <Button
              onClick={() => navigate("/faq-fahrzeug")}
              className="btn btn-orange p-3"
            >
              {t("umzug.FaqUmzug.hero_title")}
            </Button>
          </Col>
        </Row>
      </div>

      <Footer />
    </>
  );
}